var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, forwardRef } from "react";
// components
import MuiAlert from "@mui/material/Alert";
import ButtonV2 from "../ButtonV2";
import Text from "../Text";
import IconButton from "../IconButton";
// icons
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import CloseIcon from "@mui/icons-material/Close";
import { alertStylesFn } from "./Alert.styles";
import CheckCircleSvg from "../SVGLogos/CheckCircleSvg";
// constants
import { COLORS } from "../../../constants";
var Alert = function (_a, ref) {
    var _b = _a.defaultCloseIcon, defaultCloseIcon = _b === void 0 ? true : _b, _c = _a.theme, theme = _c === void 0 ? "dark" : _c, customNotificationIcon = _a.customNotificationIcon, _d = _a.showNotificationIcon, showNotificationIcon = _d === void 0 ? true : _d, // by default show notification icon but dont require it
    displayAsColumn = _a.displayAsColumn, _e = _a.iconFlexAlign, iconFlexAlign = _e === void 0 ? "center" : _e, // display icon center aligned with message or at the top left (flex-start)
    actions = _a.actions, message = _a.message, _f = _a.alertProps, alertProps = _f === void 0 ? { icon: false } : _f, onClose = _a.onClose, _g = _a.sx, sx = _g === void 0 ? {} : _g, rest = __rest(_a, ["defaultCloseIcon", "theme", "customNotificationIcon", "showNotificationIcon", "displayAsColumn", "iconFlexAlign", "actions", "message", "alertProps", "onClose", "sx"]);
    // base close icon if onclose fn exists
    var closeIcon = (_jsx(IconButton, __assign({ "aria-label": "close", variant: theme === "dark" ? "dark" : "primary", "data-testid": "icon-close-snackbar", onClick: function (e) { return (onClose ? onClose(e, "button") : undefined); } }, { children: _jsx(CloseIcon, { fontSize: "small" }) })));
    // Buttons to be displayed in alert
    var customAction = (actions === null || actions === void 0 ? void 0 : actions.length) || defaultCloseIcon ? (_jsxs(_Fragment, { children: [actions === null || actions === void 0 ? void 0 : actions.map(function (action, i) { return (_jsx(ButtonV2, __assign({ "data-testid": action.testid || action.label, variant: theme === "dark" ? "textDark" : "text" }, action, { children: action.label }), "key-".concat(i))); }), defaultCloseIcon && !displayAsColumn ? closeIcon : null] })) : undefined;
    // inner alert component props
    var customAlertProps = __assign({ severity: "success" }, alertProps);
    // if a custom icon is passed use that, otherwise use the predefined based on severity
    var statusIcon = useMemo(function () {
        if (customNotificationIcon) {
            return customNotificationIcon;
        }
        switch (customAlertProps.severity) {
            case "success":
            default:
                return _jsx(CheckCircleSvg, { color: COLORS.BRIGHT_GREEN });
            case "error":
                return _jsx(ErrorIcon, { style: { color: COLORS.ERROR_LIGHT } });
            case "warning":
                return _jsx(WarningIcon, { style: { color: COLORS.TANGERINE } });
        }
    }, [customAlertProps.severity]);
    var alertStyles = alertStylesFn({
        displayAsColumn: displayAsColumn,
        theme: theme,
        iconFlexAlign: iconFlexAlign,
        sx: sx,
    });
    return (_jsxs(MuiAlert, __assign({}, rest, { ref: ref, sx: alertStyles }, customAlertProps, { icon: showNotificationIcon ? statusIcon : false, action: customAction }, { children: [_jsx(Text, __assign({ variant: "body2", category: theme === "dark" ? "onsurface" : "primary", pr: displayAsColumn ? 2 : 0 }, { children: message })), displayAsColumn ? closeIcon : null] })));
};
export default forwardRef(Alert);
